<template src="./Navigation.html"></template>
<style src="./Navigation.scss" lang="scss"></style>

<script>
	import Burger from '@/components/Burger/Burger';

	/**
	 * The Navigation bar in header providing text links, burger menu and partner logo ads.
	 * @vue-data {string} brand The name of the current brand
	 * @vue-data {NodeList} menuReference The reference to the navigation menu
	 * @vue-data {Object[]} fullMenu An array of objects containing all menu items with their reference and their width
	 */
	export default {
		name: 'HpNavigation',
		data () {
			return {
				brand: '',
				menuReference: '',
				fullMenu: []
			};
		},
		methods: {
			/**
			 * Initializes all data fields with their respective values.
			 */
			initializeMenuPoints () {
				// as we can't do this.$el.querySelector('> ul'); we have to do it this way
				this.menuReference = Array.from(this.$el.children).filter((node) => node.nodeName === 'UL')[0];
				this.menuReference.children.forEach((navElement) => {
					this.fullMenu.push({
						reference: navElement,
						width: navElement.clientWidth
					})
				});

				this.makeMenu();
			},
			/**
			 * Remove all menu items, which will not be fully visible
			 */
			makeMenu () {
				if (this.brand === 'einsundeins') {
					return;
				}
				// clear menu to build new
				while (this.menuReference.firstChild) {
					this.menuReference.removeChild(this.menuReference.firstChild);
				}

				const menuGridGap = 30;
				const availableWidth = 600;

				let currentUsedWidth = 0;
				this.fullMenu.forEach((item, index) => {
					currentUsedWidth += item.width;
					if (index !== 0) {
						currentUsedWidth += menuGridGap;
					}

					if (currentUsedWidth < availableWidth) {
						this.menuReference.append(item.reference);
					}
				});
			}
		},
		mounted () {
			this.brand = process.env.VUE_APP_BRAND;
			this.initializeMenuPoints();
		},
		components: {
			'hp-burger': Burger
		}
	};
</script>
